import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import { FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Classes from './Review.module.css';
import { SITE } from '../../../../../data/siteConfig';

const GOOGLE_REVIEWS_URL = 'https://www.google.com/search?q=561-Fix-Home+Reviews';

/* Real Google reviews */
const reviews = [
    {
        name: 'Emil Russo',
        date: '2 weeks ago',
        rating: 5,
        text:
            'Excellent service very professional and polite they are doing several jobs for me and for flat family great people',
    },
    {
        name: 'Jennifer B',
        date: '3 weeks ago',
        rating: 5,
        text:
            'Fix Home was terrific in helping us with our cabinets. They were speedy, professional and accommodating to our schedule. We would recommend them and will call on them anytime we need help with home repairs.',
    },
    {
        name: 'Matthew Mcnulty',
        date: '3 weeks ago',
        rating: 5,
        text:
            'John was straightforward. No bullshit. Great communication. Showed up on time. Cleaned up the job when he finished. Highly recommend, and will be using again when needed. THANK YOU!!',
    },
    {
        name: 'Alejandra Octavio',
        date: '3 weeks ago',
        rating: 5,
        text:
            'Excellent experience. They are very professional, with top‑notch service and results. 100% recommended.',
    },
    {
        name: 'Lisa',
        date: '2 months ago',
        rating: 5,
        text:
            'I had an excellent experience with 561 Fix Home on a recent bathroom remodel. From start to finish, they were professional, timely, and incredibly easy to work with. Johns communication was clear throughout the project, and delivered exactly what was promised—on time and with great attention to detail.',
    },
    {
        name: 'Joseph Andrew Hays',
        date: '3 months ago',
        rating: 5,
        text:
            'The response from Bruno after hours was immediate and the next morning John and his crew the next morning were on time to our residence making a fix on a door problem with guests coming in the afternoon.',
    },
    {
        name: 'Simon S',
        date: '4 months ago',
        rating: 5,
        text:
            'I had a fabulous experience using 561 Fix Home the amount John quoted was the exact price billed. He is fastidiously clean and the time that he told me it would take to do the project is exactly the same time that it took to complete the work',
    },
    {
        name: 'Yasmine Cornelius',
        date: '4 months ago',
        rating: 5,
        text:
            'Bruno and John have helped me on multiple projects. They are thorough, responsive, and professional. When I need more work done in my house, they’ll be my first call! Thank you both!',
    },
    {
        name: 'Raphael Gross',
        date: '4 months ago',
        rating: 5,
        text:
            'John and his team are top‑notch -- we had them gut the second floor of our house and they did a fantastic job and it looks amazing. They are professional and really care about doing quality work.',
    },
];

const Stars = () => (
    <span className={Classes.stars} role="img" aria-label="5 out of 5 stars">
        {[...Array(5)].map((_, i) => <FaStar key={i} />)}
    </span>
);

function ReviewCard({ review }) {
    return (
        <figure className={Classes.card}>
            <div className={Classes.cardTop}>
                <Stars />
                <img src="/assets/icons/google.png" alt="Google review" className={Classes.gIcon} loading="lazy" />
            </div>
            <blockquote className={Classes.text}>“{review.text}”</blockquote>
            <figcaption className={Classes.author}>
                <span className={Classes.avatar} aria-hidden="true">{review.name.charAt(0)}</span>
                <span>
                    <strong>{review.name}</strong>
                    <small>{review.date}</small>
                </span>
            </figcaption>
        </figure>
    );
}

export default function Review() {
    return (
        <section id="reviews" className="section">
            <div className="container">
                <div className={`section-head center ${Classes.head}`}>
                    <div className="eyebrow">Testimonials</div>
                    <h2 className="section-title">Trusted in South Florida for 20+ Years</h2>
                    <p className={Classes.summary}>
                        <Stars />
                        <span><strong>{SITE.googleRating.value}</strong> · Based on {SITE.googleRating.count} Google reviews</span>
                    </p>
                </div>

                <div className={Classes.sliderArea}>
                <button type="button" className={Classes.prev} aria-label="Previous review"><FaChevronLeft /></button>
                <div className={Classes.sliderWrap}>
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        navigation={{ nextEl: `.${Classes.next}`, prevEl: `.${Classes.prev}` }}
                        loop
                        autoplay={{ delay: 5000, disableOnInteraction: true, pauseOnMouseEnter: true }}
                        spaceBetween={20}
                        slidesPerView={1.08}
                        breakpoints={{
                            640: { slidesPerView: 1.6 },
                            900: { slidesPerView: 2.2 },
                            1200: { slidesPerView: 3 },
                        }}
                    >
                        {reviews.map((r) => (
                            <SwiperSlide key={r.name} className={Classes.slide}>
                                <ReviewCard review={r} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <button type="button" className={Classes.next} aria-label="Next review"><FaChevronRight /></button>
                </div>

                <div className={Classes.controls}>
                    <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="btn btn-dark">
                        Read all reviews on Google
                    </a>
                </div>
            </div>
        </section>
    );
}
